import React, { Component } from 'react';
import './App.css';

import { HashRouter as Router, Route } from 'react-router-dom';

import Static from './Static';
import LinkBlock from './LinkBlock';
import TextAboutAdress from './TextAboutAdress';
import ScrollToTop from './ScrollToTop';

import { L1, L2, L3 } from '../Page/L1-L3';
import H2 from '../Page/H2';
import H3 from '../Page/H3';
import { L4, L5, L6, L7, L8, L9, L10, L11 } from '../Page/L4-L11';
import { L12, L13, L14, L15 } from '../Page/L12-L15';
import { H6, H7, H8, H9 } from '../Page/H6-H9';
import Prise from '../Page/Prise';
import Contact from '../Page/Contact';
import About from '../Page/About';

const arrH = [
  { url:'/h1', text:'Реєстрація юридичних осіб' },
  { url:'/h2', text:'Реєстрація приватних підприємців (ФОП,СПД)' },
  { url:'/h3', text:'Припинення  ФОП' },
  { url:'/h4', text:'Зміна відомостей про юридичну особу' },
  { url:'/h5', text:'Ліцензування (транспорт, тютюн, алкоголь)' },
  { url:'/h6', text:'Зміна відомостей про  ФОП' },
  { url:'/h7', text:'Готові ТОВ з ПДВ' },
  { url:'/h8', text:'Бухгалтерський супровід' },
  { url:'/h9', text:'Бенефіціари' }

];

const arrL1 = [
  { url:'/h1/l1', text:'Реєстрація ТОВ, ПП (пакетні послуги)' },
  { url:'/h1/l2', text:'Реєстрація ТОВ, ПП (окремі послуги)' },
  { url:'/h1/l3', text:'Реєстрація неприбуткових організацій' }
];

const arrL4 = [
  { url:'/h4/l4',  text:'Зміна адреси' },
  { url:'/h4/l5',  text:'Зміна керівника' },
  { url:'/h4/l6',  text:'Зміна складу засновників' },
  { url:'/h4/l7',  text:'Зміна назви' },
  { url:'/h4/l8',  text:'Зміна розміру статутного капіталу' },
  { url:'/h4/l9',  text:'Зміна КВЕД' },
  { url:'/h4/l10', text:'Зміна контактної інформації' },
  { url:'/h4/l11', text:'Зміна статуту' }
];

const arrL12 = [
  { url:'/h5/l12', text:'Ліцензія  на алкоголь' },
  { url:'/h5/l13', text:'Транспортні ліцензії для ФОП' },
  { url:'/h5/l14', text:'Транспортні ліцензії для юридичних осіб' },
  { url:'/h5/l15', text:'Ліцензія на роздрібну торгівлю тютюновими виробами' }
];


class App extends Component {
  render() {
    return (
      <Router>
        <div className="App">
          <Static>
            <ScrollToTop>
              <Route exact path="/" render={(props) => (
                                    <React.Fragment>
                                      <TextAboutAdress />
                                      <LinkBlock  items={arrH} {...props} />
                                    </React.Fragment> )} />
                <Route path="/Prise" component={Prise} />
                <Route path="/Contact" component={Contact} />
                <Route path="/About" component={About} />
                <Route exact path="/h1" render={(props) => (<LinkBlock  items={arrL1} {...props} />)} />
                  <Route path="/h1/l1" component={L1} />
                  <Route path="/h1/l2" component={L2} />
                  <Route path="/h1/l3" component={L3} />
                <Route path="/h2" component={H2} />
                <Route path="/h3" component={H3} />
                <Route exact path="/h4" render={(props) => (<LinkBlock  items={arrL4} {...props} />)} />
                  <Route path="/h4/l4" component={L4} />
                  <Route path="/h4/l5" component={L5} />
                  <Route path="/h4/l6" component={L6} />
                  <Route path="/h4/l7" component={L7} />
                  <Route path="/h4/l8" component={L8} />
                  <Route path="/h4/l9" component={L9} />
                  <Route path="/h4/l10" component={L10} />
                  <Route path="/h4/l11" component={L11} />
                <Route exact path="/h5" render={(props) => (<LinkBlock  items={arrL12} {...props} />)} />
                  <Route path="/h5/l12" component={L12} />
                  <Route path="/h5/l13" component={L13} />
                  <Route path="/h5/l14" component={L14} />
                  <Route path="/h5/l15" component={L15} />
                <Route path="/h6" component={H6} />
                <Route path="/h7" component={H7} />
                <Route path="/h8" component={H8} />
                <Route path="/h9" component={H9} />
            </ScrollToTop>
          </Static>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App.jsx